import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Telephone: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M3 9.5V6.71A3.71 3.71 0 0 1 6.71 3h1.7c1.07 0 2 .72 2.25 1.76l1.37 5.48c.23.9-.1 1.85-.86 2.41l-1.6 1.2c-.16.13-.2.31-.15.44a13.97 13.97 0 0 0 8.29 8.3c.13.04.3 0 .43-.16l1.2-1.6a2.32 2.32 0 0 1 2.42-.86l5.48 1.37A2.32 2.32 0 0 1 29 23.59v1.7A3.71 3.71 0 0 1 25.29 29H22.5A19.5 19.5 0 0 1 3 9.5Zm1.86 0c0 9.74 7.9 17.64 17.64 17.64h2.79c1.02 0 1.85-.83 1.85-1.85v-1.7c0-.22-.14-.4-.35-.45l-5.47-1.37a.47.47 0 0 0-.49.17l-1.2 1.6a2.24 2.24 0 0 1-2.56.79 15.83 15.83 0 0 1-9.4-9.4c-.35-.96.03-1.99.79-2.56l1.6-1.2c.15-.11.22-.3.17-.49L8.86 5.21a.46.46 0 0 0-.45-.35h-1.7c-1.02 0-1.85.83-1.85 1.85V9.5Z"
    />
  </Icon>
);
